import { createStore } from 'vuex';
import user from './modules/user.vuex';
import goodiebags from './modules/goodiebags.vuex';
import companies from './modules/companies.vuex';
import parentCompanies from './modules/parentCompanies.vuex';
import users from './modules/users.vuex';
import hyperlinks from './modules/hyperlink.vuex';
import contents from './modules/contents.vuex';
import search from './modules/search.vuex';
import games from './modules/games.vuex';
import game from './modules/game.vuex';
import fingerprint from './modules/fingerprint.vuex';
import communications from './modules/communications.vuex';
import links from './modules/links.vuex';
import translations from './modules/translations.vuex';
import roles from './modules/roles.vuex';
import articles from './modules/articles';
import packages from './modules/packages';
import quotes from './modules/quotes';
import terms from './modules/terms.vuex';
import legalDocuments from './modules/legalDocuments.vuex';
// import device from './modules/device.vuex';

// PV
import pvCompanies from './modules/pvCompanies.vuex';
import pvCampaigns from './modules/pvCampaigns.vuex';
import pvActivations from './modules/pvActivations.vuex';
import pvStatistics from './modules/pvStatistics.vuex';
import pvReceipts from './modules/pvReceipts.vuex';
import pvReviews from './modules/pvReviews.vuex';
import pvCashbacks from './modules/pvCashbacks.vuex';
import pvChains from './modules/pvChains.vuex';
import pvRetailers from './modules/pvRetailers.vuex';
import pvStores from './modules/pvStores.vuex';
import pvPartnerAPIs from './modules/pvPartnerAPIs.vuex';
import pvFlagged from './modules/pvFlagged.vuex';
import pvBlocked from './modules/pvBlocked.vuex';

const debug = import.meta.env.MODE !== 'production';

export default createStore({
  modules: {
    user,
    goodiebags,
    companies,
    parentCompanies,
    users,
    hyperlinks,
    contents,
    search,
    games,
    game,
    fingerprint,
    communications,
    roles,

    // Links
    links,

    translations,

    // PV
    pvCompanies,
    pvCampaigns,
    pvActivations,
    pvStatistics,
    pvReceipts,
    pvReviews,
    pvCashbacks,
    pvChains,
    pvRetailers,
    pvStores,
    pvPartnerAPIs,
    pvFlagged,
    pvBlocked,

    articles,
    packages,
    quotes,
    terms,
    legalDocuments,
  },
  strict: debug,
});
